import classNames from 'classnames'
import React, { ReactChild, ReactElement, useContext } from 'react'
import Scrollbar from 'react-scrollbars-custom'
import { ChatContext } from '~/service/chatConn'
import DateTooltip from '~/components/common/DateTooltip'
import { State as HistoryChat } from '../HistoryShow'

type SideProps = {}

const Side: React.FC<SideProps> = ({}) => {
  return (
    <div className={classNames('chat-side')}>
      <Scrollbar disableTracksWidthCompensation={true}>
        <Info />
      </Scrollbar>
    </div>
  )
}
type HistorySideProps = {
  chat: HistoryChat
}

export const HistorySide: React.FC<HistorySideProps> = ({ chat }) => {
  return (
    <div className={classNames('chat-side')}>
      <Scrollbar disableTracksWidthCompensation={true}>
        <HistoryInfo chat={chat} />
      </Scrollbar>
    </div>
  )
}

export default Side

//

type InfoProps = {}

const Info: React.FC<InfoProps> = ({}) => {
  const { activeChat: chat } = useContext(ChatContext)

  return (
    <Part label={intl.formatMessage({ id: 'chat / side / info / header' })}>
      <div className="chat-side-data">
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / page' })}
          value={
            <a target="_blank" href={chat.system.startPage}>
              {chat.system.startPage}
            </a>
          }
        />
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / system' })}
          value={chat.system.system}
        />
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / browser' })}
          value={chat.system.browser}
        />
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / ip' })}
          value={chat.system.ip}
        />
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / location' })}
          value={chat.system.location}
        />
      </div>
    </Part>
  )
}

type HistoryInfoProps = {
  chat: HistoryChat
}

const HistoryInfo: React.FC<HistoryInfoProps> = ({ chat }) => {
  return (
    <Part label={intl.formatMessage({ id: 'chat / history / show / info' })}>
      <div className="chat-side-data">
        <InfoRow
          label={intl.formatMessage({
            id: 'chat / history / show / info / startedAt',
          })}
          value={<DateTooltip date={chat.startedAt} />}
        />
        <InfoRow
          label={intl.formatMessage({
            id: 'chat / history / show / info / endedAt',
          })}
          value={chat.endedAt ? <DateTooltip date={chat.endedAt} /> : '-'}
        />
        <InfoRow
          label={intl.formatMessage({
            id: 'chat / history / show / info / system',
          })}
          value={chat.system}
        />
        <InfoRow
          label={intl.formatMessage({
            id: 'chat / history / show / info / page',
          })}
          value={chat.page}
        />
        <InfoRow
          label={intl.formatMessage({
            id: 'chat / history / show / info / location',
          })}
          value={chat.location}
        />
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / ip' })}
          value={chat.ip}
        />
        <InfoRow
          label={intl.formatMessage({ id: 'chat / side / info / browser' })}
          value={chat.browser}
        />
      </div>
    </Part>
  )
}

type InfoRowProps = {
  label: string
  value: ReactChild
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  return (
    <div className="chat-side-data">
      <div className="chat-side-data-row">
        <div className="chat-side-data-row-label">{label}</div>
        <div className="chat-side-data-row-value">{value}</div>
      </div>
    </div>
  )
}

//

type PartProps = {
  label: string
  children: React.ReactNode
}

const Part: React.FC<PartProps> = ({ children, label }) => {
  return (
    <div className="chat-side-panel">
      <div className="chat-side-panel-header">{label}</div>

      <div className="chat-side-panel-content">{children}</div>
    </div>
  )
}
